module.exports = __webpack_public_path__ + "static/car-pc/img/oil.afce55e4.svg";